import { render, staticRenderFns } from "./BasketView.vue?vue&type=template&id=1e7ad539&"
import script from "./BasketView.vue?vue&type=script&lang=js&"
export * from "./BasketView.vue?vue&type=script&lang=js&"
import style0 from "./BasketView.vue?vue&type=style&index=0&id=1e7ad539&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports